import { render, staticRenderFns } from "./CardOrderFilter.vue?vue&type=template&id=1c753d82&"
import script from "./CardOrderFilter.vue?vue&type=script&lang=js&"
export * from "./CardOrderFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports